import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import Main from '@/views/homepages/Main'
import payments from '@/router/payments'
import reports from '@/router/reports'
import customers from '@/router/customers'
import uchastki from '@/router/uchastki'
import streets from '@/router/streets'
import tariffs from '@/router/tariffs'
import controllers from '@/router/controllers'
import users from '@/router/users'
import userpays from '@/router/userpays'
import settings from '@/router/settings'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    meta: {},
    component: () => import('@/views/homepages/HomePage.vue'),
    children: [
      {
        path: '',
        name: 'Main',
        meta: {},
        component: Main,
      },
    ],
  },
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    meta: {
      title: 'Главная',
    },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
      },
      ...payments,
      ...reports,
      ...customers,
      ...uchastki,
      ...streets,
      ...tariffs,
      ...controllers,
      ...users,
      ...userpays,
      ...settings,
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/pages/Register'),
      },
    ],
  },
  {
    path: '/izveshenie4x1',
    name: 'izveshenie4x1',
    meta: {
      need_auth: false,
    },
    component: () => import('@/views/izveshenie/izveshenie4x1.vue'),
  },
  {
    path: '/izveshenie3x1',
    name: 'izveshenie3x1',
    meta: {
      need_auth: false,
    },
    component: () => import('@/views/izveshenie/izveshenie3x1.vue'),
  },
  {
    path: '/check',
    name: 'check',
    meta: {
      need_auth: false,
    },
    component: () => import('@/views/payments/check.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      need_auth: false,
    },
    component: () => import('@/views/Login.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
